import styled from 'styled-components';
import { layers, layout, typography, breakpoints } from '../../theme';

export const Wrapper = styled.div`
  bottom: 0;
  left: ${props => (props.isInactive ? '-50%' : 0)};
  position: fixed;
  top: 0;
  transition: left 0.3s ease-in-out, width 0.3s ease-in-out;
  width: ${props => (props.isActive ? 100 : 50)}%;
  z-index: ${layers.INFO};

  @media ${breakpoints.MOBILE__MQ} {
    bottom: auto;
    left: auto;
    position: relative;
    top: auto;
    width: auto;
  }
`;

export const Scroll = styled.div`
  bottom: 0;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 0;

  @media ${breakpoints.MOBILE__MQ} {
    bottom: auto;
    left: auto;
    overflow: hidden;
    position: relative;
    top: auto;
    width: auto;
  }
`;

export const Content = styled.article`
  margin: 0 auto;
  width: 40vw;

  @media ${breakpoints.MOBILE__MQ} {
    max-width: 60rem;
    padding: 0 ${layout.SPACING}rem;
    width: 100%;
  }
`;

export const TitleWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  min-height: 30rem;
  height: 50vh;
  padding-bottom: ${typography.LINE_HEIGHT * 1.4}rem;
`;

export const Title = styled.h1`
  height: 20rem;
  overflow: hidden;
  position: relative;
  text-indent: -999rem;
  width: 100%;

  svg {
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    path {
      fill: currentColor;
    }
  }

  @media ${breakpoints.MOBILE__MQ} {
    margin: 0 ${layout.SPACING}rem;
  }
`;

export const Markdown = styled.div`
  margin-bottom: ${layout.SPACING}rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Summary = styled.div`
  margin-bottom: ${layout.SPACING}rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Intro = styled.div`
  margin: 0 auto;
  text-align: center;
  width: 30vw;

  @media ${breakpoints.MOBILE__MQ} {
    width: 100%;
  }
`;

export const PagesNav = styled.nav`
  text-transform: uppercase;
`;

export const About = styled.div`
  padding-bottom: ${typography.LINE_HEIGHT * 3}rem;
`;
